<form>
    <ng-container *ngIf="!isSimpleMode">
        <n-form-item [label]="i18n.title.name">
            <span>{{data.NAME}}</span>
        </n-form-item>
        <n-form-item [label]="i18n.title.vStoreLab">
            <span>{{selectedVstore.label}}</span>
        </n-form-item>
        <n-form-item [label]="i18n.title.description">
            <span class="pre-wrap">{{data.DESCRIPTION ? data.DESCRIPTION : i18n.UNPLACEHOLDER}}</span>
        </n-form-item>
        <ng-container *ngIf="type === ScheduleTypeE.Block">
            <n-form-item [label]="i18n.title.appliedLUN" [class.hidden]="!hasLunSnapshotW">
                <n-advanced #selectedCDPToggle
                    id="cdpschedule-create-confrim-selected-lun-advanced"
                    [title]="selectedLuns.length">
                </n-advanced>
            </n-form-item>
            <n-form-item [class.hidden]="!selectedCDPToggle || !selectedCDPToggle.expand" [labelHide]="true">
                <n-data-table #lunsdt
                    id="cdpschedule-create-confrim-selected-luns-advanced-table"
                    style="height: 3rem;"
                    [columnDefs]='LUNcolumnDefs'
                    [data]='selectedLuns'>
                </n-data-table>
            </n-form-item>
            <n-form-item [label]="i18n.title.appliedPG" [class.hidden]="!hasLunSnapshotW">
                <n-advanced #selectedPGCDPToggle
                    id="cdpschedule-create-confrim-selected-pg-advanced"
                    [title]="selectedPgs.length">
                </n-advanced>
            </n-form-item>
            <n-form-item [class.hidden]="!selectedPGCDPToggle || !selectedPGCDPToggle.expand" [labelHide]="true">
                <n-data-table #pgdt
                    id="cdpschedule-create-confrim-selected-pg-advanced-table"
                    style="height: 3rem;"
                    [columnDefs]='PGcolumnDefs'
                    [data]='selectedPgs'>
                </n-data-table>
            </n-form-item>
            <n-form-item [label]="i18n.create.wormTab">
                <span>{{ render.enable(data.SECURESNAPENABLED) }}</span>
            </n-form-item>
            <ng-container *ngIf="data.SECURESNAPENABLED">
                <n-form-item [label]="i18n.create.protectTime">
                    <span>{{render.protectTime(data.PROTECTPERIOD, data.PROTECTPERIODUNIT)}}</span>
                </n-form-item>
                <n-form-item [label]="i18n.create.enableAutoDelete">
                    <span>{{render.enable(data.AUTODELETEENABLED)}}</span>
                </n-form-item>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="type === ScheduleTypeE.File">
            <n-form-item [label]="i18n.title.appliedFS" [class.hidden]="!hasFsSnapshotW">
                <n-advanced #selectedFSCDPToggle
                    id="cdpschedule-create-confrim-selected-fs-advanced"
                    [title]="selectedFS.length">
                </n-advanced>
            </n-form-item>
            <n-form-item [class.hidden]="!selectedFSCDPToggle || !selectedFSCDPToggle.expand" [labelHide]="true">
                <n-data-table #fsdt
                    id="cdpschedule-create-confrim-selected-fs-advanced-table"
                    style="height: 3rem;"
                    [columnDefs]='FScolumnDefs'
                    [data]='selectedFS'>
                </n-data-table>
            </n-form-item>
        </ng-container>

        <n-form-item [label]="i18n.title.executedPolicy">
            <ng-container
                *ngIf="isFixed">
                <div class="interval-10 mt-10 custom-width show-policy-class">{{fixedLabel}}</div>
                <div *ngIf="(!data.SECURESNAPENABLED && type === ScheduleTypeE.Block) || (type === ScheduleTypeE.File && !data.FREQUENCYSECURESNAPENABLED)" class="interval-10 custom-width show-policy-class">{{fixedRetainLabel}}</div>
                <ng-container *ngIf="type === ScheduleTypeE.File">
                    <div class="interval-10 custom-width show-policy-class">
                        <span>{{i18n.create.wormTab}}</span>
                        <span class="show-policy-content">{{render.enable(data.FREQUENCYSECURESNAPENABLED)}}</span>
                    </div>
                    <ng-container *ngIf="data.FREQUENCYSECURESNAPENABLED">
                        <div class="interval-10 custom-width show-policy-class">
                            <span>{{i18n.create.protectTime}}</span>
                            <span class="show-policy-content">{{render.protectTime(data.FREQUENCYPROTECTPERIOD, data.FREQUENCYPERIODUNIT)}}</span>
                        </div>
                        <div class="interval-10 custom-width show-policy-class">
                            <span>{{i18n.create.enableAutoDelete}}</span>
                            <span class="show-policy-content">{{render.enable(data.FREQUENCYAUTODELETEENABLED)}}</span>
                        </div>
                    </ng-container>
                    <div *ngIf="!isUndefined(data.FREQUENCYTAG)"
                        class="interval-10 custom-width show-policy-class">
                        <span>{{i18n.title.detailSnapshotTag}}</span>
                        <span class="show-policy-content">{{data.FREQUENCYTAG}}</span>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container
                *ngIf="isDaily">
                <div class="interval-10 mt-10 custom-width show-policy-class">{{dayLabel}}</div>
                <div *ngIf="(!data.SECURESNAPENABLED && type === ScheduleTypeE.Block) || (type === ScheduleTypeE.File && !data.DAYSECURESNAPENABLED)" class="interval-10 custom-width show-policy-class">{{dayRetainLabel}}</div>
                <ng-container *ngIf="type === ScheduleTypeE.File">
                    <div class="interval-10 custom-width show-policy-class">
                        <span>{{i18n.create.wormTab}}</span>
                        <span class="show-policy-content">{{render.enable(data.DAYSECURESNAPENABLED)}}</span>
                    </div>
                    <ng-container *ngIf="data.DAYSECURESNAPENABLED">
                        <div class="interval-10 custom-width show-policy-class">
                            <span>{{i18n.create.protectTime}}</span>
                            <span class="show-policy-content">{{render.protectTime(data.DAYPROTECTIONPERIOD, data.DAYPERIODUNIT)}}</span>
                        </div>
                        <div class="interval-10 custom-width show-policy-class">
                            <span>{{i18n.create.enableAutoDelete}}</span>
                            <span class="show-policy-content">{{render.enable(data.DAYAUTODELETEENABLED)}}</span>
                        </div>
                    </ng-container>
                    <div *ngIf="!isUndefined(data.DAYTAG)"
                        class="interval-10 custom-width show-policy-class">
                        <span>{{i18n.title.detailSnapshotTag}}</span>
                        <span class="show-policy-content">{{data.DAYTAG}}</span>
                    </div>
                </ng-container>
            </ng-container>

            <ng-container
                *ngIf="isWeekly">
                <div class="interval-10 mt-10 custom-width show-policy-class">{{weekLabel}}</div>
                <div *ngIf="(!data.SECURESNAPENABLED && type === ScheduleTypeE.Block) || (type === ScheduleTypeE.File && !data.WEEKLYSECURESNAPENABLED)" class="interval-10 custom-width show-policy-class">{{weekRetainLabel}}</div>
                <ng-container *ngIf="type === ScheduleTypeE.File">
                    <div class="interval-10 custom-width show-policy-class">
                        <span>{{i18n.create.wormTab}}</span>
                        <span class="show-policy-content">{{render.enable(data.WEEKLYSECURESNAPENABLED)}}</span>
                    </div>
                    <ng-container *ngIf="data.WEEKLYSECURESNAPENABLED">
                        <div class="interval-10 custom-width show-policy-class">
                            <span>{{i18n.create.protectTime}}</span>
                            <span class="show-policy-content">{{render.protectTime(data.WEEKLYPROTECTIONPERIOD, data.WEEKLYPERIODUNIT)}}</span>
                        </div>
                        <div class="interval-10 custom-width show-policy-class">
                            <span>{{i18n.create.enableAutoDelete}}</span>
                            <span class="show-policy-content">{{render.enable(data.WEEKLYAUTODELETEENABLED)}}</span>
                        </div>
                    </ng-container>
                    <div *ngIf="!isUndefined(data.WEEKLYTAG)"
                        class="interval-10 custom-width show-policy-class">
                        <span>{{i18n.title.detailSnapshotTag}}</span>
                        <span class="show-policy-content">{{data.WEEKLYTAG}}</span>
                    </div>
                </ng-container>
            </ng-container>

            <ng-container
                *ngIf="isMonthly">
                <div class="interval-10 mt-10 custom-width show-policy-class">{{monthLabel}}</div>
                <div *ngIf="(!data.SECURESNAPENABLED && type === ScheduleTypeE.Block) || (type === ScheduleTypeE.File && !data.MONTHSECURESNAPENABLED)" class="interval-10 custom-width show-policy-class">{{monthRetainLabel}}</div>
                <ng-container *ngIf="type === ScheduleTypeE.File">
                    <div class="interval-10 custom-width show-policy-class">
                        <span>{{i18n.create.wormTab}}</span>
                        <span class="show-policy-content">{{render.enable(data.MONTHSECURESNAPENABLED)}}</span>
                    </div>
                    <ng-container *ngIf="data.MONTHSECURESNAPENABLED">
                        <div class="interval-10 custom-width show-policy-class">
                            <span>{{i18n.create.protectTime}}</span>
                            <span class="show-policy-content">{{render.protectTime(data.MONTHPROTECTIONPERIOD, data.MONTHPERIODUNIT)}}</span>
                        </div>
                        <div class="interval-10 custom-width show-policy-class">
                            <span>{{i18n.create.enableAutoDelete}}</span>
                            <span class="show-policy-content">{{render.enable(data.MONTHAUTODELETEENABLED)}}</span>
                        </div>
                    </ng-container>
                    <div *ngIf="!isUndefined(data.MONTHTAG)"
                        class="interval-10 custom-width show-policy-class">
                        <span>{{i18n.title.detailSnapshotTag}}</span>
                        <span class="show-policy-content">{{data.MONTHTAG}}</span>
                    </div>
                </ng-container>
            </ng-container>
        </n-form-item>
    </ng-container>

    <n-form-item labelHide="true">
        <n-checkbox
            id='cdpschedule-create-confrim-activate-check-box'
            [label]="i18n.table.activateBtn"
            [(ngModel)]="isActive"
            [ngModelOptions]="{standalone: true}">
        </n-checkbox>
    </n-form-item>
</form>
